export default __webpack_public_path__ + "static/media/das_frank.30f29383.png";